import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { key: 1 }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import auth from '@/core/Auth';
import { Loader } from '@/core/Loader';
import { Flash } from '@/core/Flash';
import LoginLayout from '@/modules/login/components/LoginLayout.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import FaIcon from '@/core/components/FaIcon.vue';
import AppInput from '@/core/components/form/AppInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetRequest',
  setup(__props) {

const { $gettext } = useGettext();
const email = ref<string>('');
const requested = ref<boolean>(false);

const request = () => {
	Loader.show();
	auth.passwordResetRequest(email.value)
		.then(() => requested.value = true)
		.catch((e) => {
			Flash.fromError(e)
		})
		.finally(() => Loader.hide());
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(LoginLayout, {
    "page-title": _unref($gettext)('Glömt lösenord?')
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("h2", null, [
        _createTextVNode("Glömt lösenord?")
      ])), [
        [_directive_translate]
      ]),
      (!requested.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _withModifiers(request, ["prevent"])
          }, [
            _withDirectives((_openBlock(), _createElementBlock("p", null, [
              _createTextVNode(" Skriv in din e-postadress här nedanför så skickar vi en länk till dig för att ställa in ett nytt lösenord. ")
            ])), [
              [_directive_translate]
            ]),
            _createVNode(AppFormGroup, {
              id: "password_reset_email",
              label: _unref($gettext)('E-postadress')
            }, {
              default: _withCtx(() => [
                _createVNode(AppInput, {
                  id: "password_reset_email",
                  modelValue: email.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(AppButton, {
              type: "submit",
              class: "button-block"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Skicka återställningslänk")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 40, _hoisted_1))
        : _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(" Har du ett konto hos oss kommer du att få en länk utskickad inom några minuter. Följ länken för att ställa in ett nytt lösenord. ")
          ])), [
            [_directive_translate]
          ]),
      _createElementVNode("p", null, [
        _createVNode(_component_RouterLink, { to: {name: 'login'} }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "arrow-left" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [
                _createTextVNode("Gå tillbaka")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})